import { SET_USER_INFORMATION, RESET_INVESTOR } from '../constant';

const INIT_STATE = {
  user: { userType: 2, isAuthenticated: false },
};

const Investor = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_USER_INFORMATION: {
      return {
        ...state,
        user: action?.payload ?? { userType: 2, isAuthenticated: false },
      };
    }

    case RESET_INVESTOR: {
      return {
        user: { userType: 2, isAuthenticated: false },
        bankDetails: null,
      };
    }

    default:
      return state;
  }
};

export default Investor;
